import goodsOrder from "@/components/goodsOrder.vue";
export default {
  name: "orderConfirm",
  components: { goodsOrder },
  data() {
    return {
      loading: false,
      orderGoodsInfo: [
        {
          storeImg: '//pic.ule.com/pic/user_800109092/product/prd20190709/4a929d5e5a25eea8_p750x750.jpg',
          storeName: '四川原产地直营商店',
          goodsList: [
            { "id": 1, "name": "商品1", "img": "//pic.ule.com/pic/user_800109092/product/prd20190709/4a929d5e5a25eea8_p750x750.jpg" },
            { "id": 2, "name": "商品2", "img": "//pic.ule.com/pic/user_800109092/product/prd20190709/4a929d5e5a25eea8_p750x750.jpg" },
            { "id": 3, "name": "商品3", "img": "//pic.ule.com/pic/user_800109092/product/prd20190709/4a929d5e5a25eea8_p750x750.jpg" },
            { "id": 4, "name": "商品4", "img": "//pic.ule.com/pic/user_800109092/product/prd20190709/4a929d5e5a25eea8_p750x750.jpg" },
            { "id": 5, "name": "商品5", "img": "//pic.ule.com/pic/user_800109092/product/prd20190709/4a929d5e5a25eea8_p750x750.jpg" },
            { "id": 6, "name": "商品6", "img": "//pic.ule.com/pic/user_800109092/product/prd20190709/4a929d5e5a25eea8_p750x750.jpg" },
          ],
          // 优惠券
          showCouponList: false,
          chosenCoupon: -1,
          coupons: [
            {
              available: 1,
              id: '1223322',//优惠券 id
              name: '优惠券名称',
              condition: '无使用门槛\n最多优惠12元',//满减条件
              description: '',
              reason: '不可用原因',
              value: 150,//折扣券优惠金额，单位分
              startAt: 1489104000,
              endAt: 1514592000,
              valueDesc: '1.5',//折扣券优惠金额文案
              unitDesc: '元'
            },
            {
              available: 2,
              id: '1223',//优惠券 id
              name: '优惠券',
              condition: '无使用门槛\n最多优惠15元',//满减条件
              description: '',
              reason: '不可用原因',
              value: 350,//折扣券优惠金额，单位分
              startAt: 1489104000,
              endAt: 1514592000,
              valueDesc: '3.5',//折扣券优惠金额文案
              unitDesc: '元'
            }
          ],
          couponsPrice: 0,
          disabledCoupons: [],
          sendMsg: '',
          price: 12,
          transpPrice: 5,
          salesPrice: 0
        },
        {
          storeImg: '//pic.ule.com/pic/user_800109092/product/prd20190709/4a929d5e5a25eea8_p750x750.jpg',
          storeName: 'shanghai原产地直营商店',
          goodsList: [
            { "id": 1, "name": "商品1", "img": "//pic.ule.com/pic/user_800109092/product/prd20190709/4a929d5e5a25eea8_p750x750.jpg" },
            { "id": 2, "name": "商品2", "img": "//pic.ule.com/pic/user_800109092/product/prd20190709/4a929d5e5a25eea8_p750x750.jpg" },
            { "id": 3, "name": "商品3", "img": "//pic.ule.com/pic/user_800109092/product/prd20190709/4a929d5e5a25eea8_p750x750.jpg" },
            { "id": 4, "name": "商品4", "img": "//pic.ule.com/pic/user_800109092/product/prd20190709/4a929d5e5a25eea8_p750x750.jpg" },
            { "id": 5, "name": "商品5", "img": "//pic.ule.com/pic/user_800109092/product/prd20190709/4a929d5e5a25eea8_p750x750.jpg" },
            { "id": 6, "name": "商品6", "img": "//pic.ule.com/pic/user_800109092/product/prd20190709/4a929d5e5a25eea8_p750x750.jpg" },
          ],
          // 优惠券
          showCouponList: false,
          chosenCoupon: -1,
          coupons: [
            {
              available: 1,
              id: '1223322',//优惠券 id
              name: '优惠券名称',
              condition: '无使用门槛\n最多优惠12元',//满减条件
              description: '',
              reason: '不可用原因',
              value: 150,//折扣券优惠金额，单位分
              startAt: 1489104000,
              endAt: 1514592000,
              valueDesc: '1.5',//折扣券优惠金额文案
              unitDesc: '元'
            },
            {
              available: 2,
              id: '1223',//优惠券 id
              name: '优惠券',
              condition: '无使用门槛\n最多优惠15元',//满减条件
              description: '',
              reason: '不可用原因',
              value: 350,//折扣券优惠金额，单位分
              startAt: 1489104000,
              endAt: 1514592000,
              valueDesc: '3.5',//折扣券优惠金额文案
              unitDesc: '元'
            }
          ],
          couponsPrice: 0,
          disabledCoupons: [],
          sendMsg: '',
          price: 65,
          transpPrice: 5,
          salesPrice: 0
        },
        {
          storeImg: '//pic.ule.com/pic/user_800109092/product/prd20190709/4a929d5e5a25eea8_p750x750.jpg',
          storeName: '直营商店',
          goodsList: [
            { "id": 1, "name": "商品1", "img": "//pic.ule.com/pic/user_800109092/product/prd20190709/4a929d5e5a25eea8_p750x750.jpg" },
            { "id": 2, "name": "商品2", "img": "//pic.ule.com/pic/user_800109092/product/prd20190709/4a929d5e5a25eea8_p750x750.jpg" },
            { "id": 3, "name": "商品3", "img": "//pic.ule.com/pic/user_800109092/product/prd20190709/4a929d5e5a25eea8_p750x750.jpg" },
            { "id": 4, "name": "商品4", "img": "//pic.ule.com/pic/user_800109092/product/prd20190709/4a929d5e5a25eea8_p750x750.jpg" },
            { "id": 5, "name": "商品5", "img": "//pic.ule.com/pic/user_800109092/product/prd20190709/4a929d5e5a25eea8_p750x750.jpg" },
            { "id": 6, "name": "商品6", "img": "//pic.ule.com/pic/user_800109092/product/prd20190709/4a929d5e5a25eea8_p750x750.jpg" },
          ],
          // 优惠券
          showCouponList: false,
          chosenCoupon: -1,
          coupons: [
            {
              available: 1,
              id: '1223322',//优惠券 id
              name: '优惠券名称',
              condition: '无使用门槛\n最多优惠12元',//满减条件
              description: '',
              reason: '不可用原因',
              value: 150,//折扣券优惠金额，单位分
              startAt: 1489104000,
              endAt: 1514592000,
              valueDesc: '1.5',//折扣券优惠金额文案
              unitDesc: '元'
            },
            {
              available: 2,
              id: '1223',//优惠券 id
              name: '优惠券',
              condition: '无使用门槛\n最多优惠15元',//满减条件
              description: '',
              reason: '不可用原因',
              value: 350,//折扣券优惠金额，单位分
              startAt: 1489104000,
              endAt: 1514592000,
              valueDesc: '3.5',//折扣券优惠金额文案
              unitDesc: '元'
            }
          ],
          couponsPrice: 0,
          disabledCoupons: [],
          sendMsg: '',
          price: 65,
          transpPrice: 10,
          salesPrice: -25.2
        }
      ],
      totlaPrice: 0
    };
  },
  computed: {
    getTotalPrice() {
      let totalPrice = 0
      this.orderGoodsInfo.map(function (item) {
        totalPrice += Number(item.price) + Number(item.transpPrice) + Number(item.salesPrice) - Number(item.couponsPrice)
      });
      return totalPrice * 100
    }
  },
  created() { },
  mounted() { },
  beforeCreate() { },
  methods: {
    onBack() {
      history.back();
    },
    changeAddr() {
      this.$router.push({
        path: "/address/addressList",
        query: {
          listId: 123
        }
      });
    },
    onSubmit() {
    },
  }
};